import consumer from "./consumer"

consumer.subscriptions.create("SyncStripeObjectsChannel", {
  received(data) {
    // DOM elements
    const syncButton = document.querySelector("#sync-button");
    const progressBar = document.querySelector(".progress-bar");
    const syncStatusMessage = document.querySelector(".sync-status-message");

    // Handle errors if any
    if (data.errors && data.errors.length > 0) {
      syncStatusMessage.classList.add("active");
      console.error("Errors occurred during sync:", data.errors.join("\n"));
      // Display the first error in the status message, or handle as needed
      syncStatusMessage.textContent = "Error: " + data.errors;
      syncStatusMessage.classList.add("error");
    }

    // Update UI with the progress
    progressBar.style.width = `${data.progress}%`;
    progressBar.textContent = `Progress: ${data.progress}%`;

    if (data.progress < 100) {
      // Sync is in progress
      progressBar.classList.add("active");
      syncStatusMessage.classList.add("active");
      syncStatusMessage.textContent = `Syncing... (${data.processed}/${data.total} items processed)`;
      syncButton.textContent = "Syncing...";
      syncButton.disabled = true;
    } else {
      // Sync is complete
      syncStatusMessage.textContent = `Sync complete!`;
      setTimeout(() => {
        syncStatusMessage.textContent = `Sync complete! (${data.processed}/${data.total} items processed)`;
        progressBar.classList.remove("active");
        syncButton.textContent = "Sync to Stripe";
        syncButton.disabled = false;
        if (data.errors.length == 0) syncStatusMessage.classList.remove("active");
      }, 10000);
    }
  }
});
